



































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
@Component
export default class SliderToggler extends Vue {
    isEdit = false;

    @Watch("isEdit")
    isEditChanged(val){
        this.$emit("isEditChangedOn",val);
    }

    cancelChanges(){
        this.isEdit = false
        this.$emit("cancelChanges");
    }
    applyChanges(){
        this.isEdit = false
        this.$emit("applyChanges");
    }
}
